import SoftBadge from "modules/common/SoftBadge";
import React, { useEffect, useState, useMemo } from "react";
import { useMonthKitData } from "./store";
import { Offcanvas, Button } from "react-bootstrap";
import RecommendationModal from "./RecommendationModal";
import CopyComponent from "./CopyComponent";

function RecommendationScrollableTabHeader({ dates, setActiveTab, case_id }) {
  const [active, setActive] = useState(0);
  const [isFirstModalVisible, setFirstModalVisible] = useState(false);
  const { kitData, fetchMonthKitData } = useMonthKitData();
  const mappedFirstMed = useMemo(() => {
    return kitData?.nextMonthProductDetails?.map((item) => {
      return { name: item?.name, quantity: item?.quantity?._1month };
    });
  }, [kitData]);

  useEffect(() => {
    fetchMonthKitData(case_id);
  }, []);

  const handleFirstClickSave = () => {
    setFirstModalVisible(!isFirstModalVisible);
  };

  return (
    <div
      className="d-flex align-items-center justify-content-between"
      style={{ width: "99%" }}
    >
      <div
        style={{ overflowX: "auto" }}
        className="p-2 d-flex align-items-center flex-nowrap scrollable-container"
      >
        {dates?.map((date, index) => {
          return active === index && !isNaN(active) ? (
            <SoftBadge
              className="p-3"
              key={index}
              style={{ minWidth: "14rem" }}
            >
              {date}
            </SoftBadge>
          ) : (
            <p
              key={index}
              style={{ minWidth: "13rem" }}
              className="m-0 p-2 rounded cursor-pointer"
              onClick={() => {
                setActive(index);
                setActiveTab(date);
              }}
            >
              {date}
            </p>
          );
        })}
      </div>
      <div className="d-flex align-items-center gap-2">
        <Offcanvas.Header>
          <CopyComponent
            copyText={`https://form.traya.health/reorder-feedback/${case_id}`}
            afterCopiedPropmpt={"Feedback Form Link Copied! "}
            buttonText={'Feedback Form'}
          />
        </Offcanvas.Header>
        <Offcanvas.Body className="scrollable-section mt-n4">
          <RecommendationModal
            isModalVisible={isFirstModalVisible}
            setIsModalVisible={setFirstModalVisible}
            mappedData={mappedFirstMed}
            handleOnClick={handleFirstClickSave}
            firstMonth={true}
          />
        </Offcanvas.Body>
        <Button style={{ height: "2.5rem" }} onClick={handleFirstClickSave}>
          <span className="pe-1 text-truncate">
            Next Order Kit
            <span className="ms-1"></span>
          </span>
        </Button>
      </div>
    </div>
  );
}

export default RecommendationScrollableTabHeader;
